import * as React from "react";
import {RouteComponentProps} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {ContainerBox} from "myshubhlife-component/container-box";
import "./style.scss";
import Options from "IncompleteInfoV2/CategoryList/options";
import {COLOR} from "utils/variables";
import {handleNavigation, routePaths} from "IncompleteInfoV2/routes";
import {ILoanApplicationInfo} from "StateInterface";
import {ApplicationStatus} from "profile/enums";
import {IScreens} from "IncompleteInfoV2/interface";
import {useEffect} from "react";
import {AndroidApis} from "app";
import {ILatestStatus} from "profile/interface";

interface IConnectProps {
    dispatch?: (action: any) => void;
    isAndroid: boolean;
    userId: number;
    screens: IScreens;
    applicationInfo: ILatestStatus;
}

const CategoryList = (props: IConnectProps & RouteComponentProps) => {
    useEffect(() => {
        if (props.isAndroid) {
            AndroidApis.clearWebStack();
        }
    }, []);
    const handleOptionClick = (status: string, index: number) => {
        if (routePaths[status]) {
            handleNavigation(routePaths[status]);
        }
    };
    return (
        <ContainerBox backgroundColor={COLOR.WHITE}>
            <div>
                {
                    props.applicationInfo &&
                    props.applicationInfo.status === ApplicationStatus.INCOMPLETE_INFO &&
                    props.screens &&
                    Object.keys(props.screens).map((status, index) => {
                        return (
                            <Options
                                heading={props.screens[status].heading}
                                description={props.screens[status].message}
                                handleClick={() => handleOptionClick(status, index)}
                                key={index}
                            />
                        );
                    })
                }
            </div>
        </ContainerBox>
    );
};

const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        isAndroid: state.login.isAndroid,
        userId: state.login.auth.userId,
        applicationInfo: state?.profileInfo?.latestStatus,
        screens: state.incompleteInfoV2.screens,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(CategoryList);
